import React from "react";
import PropTypes from "prop-types";

import SearchBar from "src/app/components/SearchBar/SearchBar";
import SearchBarStyles from "src/app/components/SearchBar/SearchBar.module.css";
import SearchHeader from "src/app/components/SearchHeader/SearchHeader";
import iconsMap from "src/assets/iconsMap";
import styles from "./NoResultsSearchList.module.css";

const NoResultsSearchList = ({
  noFaqsFound = "",
  placeholder,
  searchHeaderTitle,
  query = "",
}) => {
  const noFaqs = noFaqsFound.replace("<x>", query);
  const Icon = iconsMap("Search");

  const [firstLine, secondLine] = noFaqs.split("\r\n");

  return (
    <>
      <SearchHeader title={searchHeaderTitle} query={query} />
      <div className={styles.searchContainer}>
        <SearchBar
          placeholder={placeholder}
          styles={SearchBarStyles}
          displayDropdown={true}
          type="search-page"
        />
      </div>
      <div className={styles.searchIconContainer}>
        <Icon />
      </div>
      {firstLine && <p className={styles.noFoundFaqs}>{firstLine}</p>}
      {secondLine && <p className={styles.noFoundFaqs2}>{secondLine}</p>}
    </>
  );
};

export default NoResultsSearchList;

NoResultsSearchList.propTypes = {
  noFaqsFound: PropTypes.string,
  searchHeaderTitle: PropTypes.string,
  placeholder: PropTypes.string,
  query: PropTypes.string,
};
